import { postLogDetails } from '../Services/APIs/scan';

export const logUserAction = async (action, uid = 'anonymous') => {
  try {
    const payload = {
      app: 'toothlens',
      uid,
      payload: action
    };
    await postLogDetails(payload);
  } catch (error) {
    console.error('Error logging user action:', error);
    // Fail silently - we don't want logging to break the app
  }
};
